import AsyncSelect from "react-select/async";

const CommonAutoComplete = ({
  value,
  onChange,
  api,
  placeholder,
  name,
  extraParams,
}) => {
  const loadOptions = async (inputValue) => {
    if (!inputValue?.trim() || inputValue.trim().length < 2) {
      return [];
    }

    // if extraParams required but not available
    if (name === "stateId" && !extraParams?.countryId) {
      return [];
    }

    try {
      const data = extraParams
        ? await api(extraParams.countryId)
        : await api(inputValue);
      debugger;
      return (
        data?.map((item) => ({
          label:
            item?.supplierName ||
            item?.carrierName ||
            item?.cityName ||
            item?.countryName ||
            item.stateName ||
            item.apiGateway ||
            item.username,

          id: item?.id || item.apiGateway || item.userId,
        })) || []
      );
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions={extraParams ? true : false}
      loadOptions={loadOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      name={name}
      isClearable
    />
  );
};

export default CommonAutoComplete;
